import KioskProductionListStatus from './KioskProductionListStatus'
export default KioskProductionListStatus
